var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mechanism-text font-h6-regular"},[_vm._v("服务费率："+_vm._s(_vm.row.serviceFeeRate)+"%")]),_c('div',{staticClass:"mechanism-text font-h6-regular"},[_vm._v("达人佣金率："+_vm._s(_vm.row.talentCommission)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }